import { Component, Input, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState, FramesActionTypes, FrameReturnsActionTypes, selectProgram } from '@app/core/ngrx';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { User } from '@app/core/models';
import { State } from '@ngrx/store';
import { VWProgram } from '@app/core/models/user.model';
import { faWindowRestore } from '@fortawesome/free-solid-svg-icons';
// import { ConfirmNotificationComponent } from '@app/return/components/confirm-notification/confirm-notification.component';

@Component({
  selector: 'ecp-return-frame-details',
  templateUrl: './return-frame-details.component.html',
  styleUrls: ['./return-frame-details.component.scss'],
})
export class ReturnFrameDetailsComponent implements OnInit, OnDestroy {
  FrameDetails: FormGroup;
  returnReasons: Array<Reason> = [
    { text: 'Manufacturer Defect', value: '1' },
    { text: 'Excess Inventory', value: '2' },
    { text: 'Forgot Refresh', value: '3' },
    { text: 'Mis-shipment', value: '4' },
  ];
  defectReasons: Array<Reason> = [
    { text: 'Frame Coating', value: '1' },
    { text: 'Poor Finishing', value: '2' },
    { text: 'Mis-Aligned', value: '3' },
    { text: 'Missing Components', value: '4' },
    { text: 'Breakage', value: '5' },
    { text: 'Soldering Issue', value: '6' },
    { text: 'Functionality', value: '7' },
    { text: 'Other defect', value: '8' },
  ];
  url = '/frame-return';
  @Input() frame;
  frame$: Observable<any>;
  disableDefect = true;
  upc: any = null;
  loaded = true;
  public program$: Observable<VWProgram>;
  theme = 'one-portal';

  constructor(
    private fb: FormBuilder,
    private state: State<AppState>,
    private store: Store<AppState>,
    private router: Router,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ReturnFrameDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.frame$ = this.store.pipe(select(myState => myState.frameDetails));

    this.upc = data.upc;
    let frameList = this.state.getValue().frames.list.frames;
    if (frameList.length === 0) {
      this.store.dispatch({
        type: FramesActionTypes.LOAD_FRAME_DETAILS,
        payload: {
          terms: [data.upc],
          brands: [],
          sizes: [],
          skip: 0,
        },
      });
    } else {
      this.store.dispatch({
        type: FramesActionTypes.LOAD_FRAME_DETAILS_SUCCESS,
        payload: frameList.filter(f => f.upc === data.upc)[0],
      });
    }

    this.frame$.subscribe(frame => {
      if (frame && frame.loaded) {
        this.frame = frame.frame;
      }
    });
  }

  get returnReason(): AbstractControl {
    return this.FrameDetails.get('returnReason');
  }

  get defectReason(): AbstractControl {
    return this.FrameDetails.get('defectReason');
  }

  get patientName(): AbstractControl {
    return this.FrameDetails.get('patientName');
  }

  get purchaseDate(): AbstractControl {
    return this.FrameDetails.get('purchaseDate');
  }

  /**
   * ngOnInit
   * @description
   */
  ngOnInit(): void {
    if (!this.FrameDetails) {
      this.FrameDetails = this.fb.group({
        returnReason: '',
        defectReason: '',
        patientName: '',
        purchaseDate: '',
      });
    }
    this.program$ = this.store.pipe(select(selectProgram));
    this.program$.pipe().subscribe(program => {
      if (program) {
        this.theme = program.programKey;
      }
    });
  }

  setReturnReason() {
    let reason = this.FrameDetails.controls.returnReason.value;
    if (reason.value !== 1) this.FrameDetails.get('defectReason').reset();
  }

  checkReturnable(reason) {
    if (!this.frame.isReturnable && reason.value === '3') return true;
    else return false;
  }

  isAddButtonDisabled() {
    return this.FrameDetails.invalid || this.FrameDetails.controls.returnReason.value === '';
  }

  disableDefectReason() {
    let flag = this.FrameDetails.controls.returnReason.value.value !== '1';
    return flag;
  }

  SaveAndGoToCart() {
    this.addFrameToReturns();
    this.dialogRef.afterClosed().subscribe(res=>{
      this.router.navigateByUrl('/returns-cart');  
    });
  }

  SaveAndClose() {
    this.addFrameToReturns();
  }

  addFrameToReturns() {
    let reason = this.FrameDetails.controls.returnReason.value;
    let defect = this.FrameDetails.controls.defectReason.value;

    this.store.dispatch({
      type: FrameReturnsActionTypes.ADD_FRAME_TO_RETURNS,
      payload: {
        brandName: this.frame.brandName,
        smallImageUrl: this.frame.smallImageUrl,
        largeImageUrl: this.frame.largeImageUrl,
        styleName: this.frame.styleName,
        colorDescription: this.frame.colorDescription,
        eyeSize: this.frame.eyeSize,
        temple: this.frame.temple,
        upc: this.frame.upc,
        fpc: this.frame.fpc,
        patientName: this.patientName.value,
        purchaseDate: this.purchaseDate.value !== '' ? this.purchaseDate.value.toLocaleDateString('en-US') : '',
        returnReason: reason.text,
        defectReason: defect !== null ? defect.text : '',
      },
    });
  }

  ngOnDestroy() {}

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  compareValues(o1: any, o2: any) {
    try {
      if (o1.value === o2.value) {
        return true;
      } else {
        return false;
      }
    } catch (e) {}
  }

  getTooltipText() {
    return `Manufacturer Defect - Examples are premature flaking of coating, soldering defects, but not normal wear and tear, accidents, or abuse
    
    Excess Inventory - In "Like New" condition with all original accessories (leaflets, cleaning cloths, demo lenses, case, etc)

    Forgot Refresh - Frames that were recalled in a previous refresh but were not returned at that time

    Mis-shipment - Frames that were received in error.  Ordered one frame but received another.
`;
  }
}

class Reason {
  text: string;
  value: string;
}
